import { render, staticRenderFns } from "./UserRegister.vue?vue&type=template&id=3db81cdc&scoped=true"
import script from "./UserRegister.vue?vue&type=script&lang=js"
export * from "./UserRegister.vue?vue&type=script&lang=js"
import style0 from "./UserRegister.vue?vue&type=style&index=0&id=3db81cdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db81cdc",
  null
  
)

export default component.exports